module.exports = __webpack_public_path__ + "static/media/vote-btn.f618ab35.svg";